import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import mixpanel from 'mixpanel-browser';
import { TextField, Button } from '@mui/material';
import NavBar from '../../NavBar';
import { Footer } from '../Footer';
import { financeMortgage, surveyText, surveyBtnAnswers } from '../../../constants/Footer/survey';
import { SurveyBtns } from './SurveyBtns';
import { postSurvey } from '../../../actions/index.js';

import './Survey.css';

export const FinanceMortgage = () => {
  const [answerChosen, setAnswerChosen] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    mixpanel.track('Finance Mortgage Survey Page', {
      path: '/survey_finance_mortgage',
    });
  }, []);

  const handleAnswer = (question, answer) => {
    setAnswerChosen((prevState) => ({
      ...prevState,
      [question]: answer,
    }));
  };

  const handleSubmit = async () => {
    if (Object.keys(answerChosen).length < 15) {
      //hard coded length of questions
      alert('Please answer all questions before submitting!');
      return;
    }
    //track survey submission
    mixpanel.track('Finance Mortgage Survey Submitted', {
      path: '/survey_finance_mortgage',
      answers: answerChosen,
    });

    const surveyData = financeMortgage.map((item) => ({
      questionsEasy: item.questionsEasy?.map((question) => ({
        question,
        answer: answerChosen[question],
      })),
      questionsYesNo: item.questionsYesNo?.map((question) => ({
        question,
        answer: answerChosen[question],
      })),
      questionsLikely: item.questionsLikely?.map((question) => ({
        question,
        answer: answerChosen[question],
      })),
      questionsSatisfied: item.questionsSatisfied?.map((question) => ({
        question,
        answer: answerChosen[question],
      })),
      questionsGoodPoor: item.questionsGoodPoor?.map((question) => ({
        question,
        answer: answerChosen[question],
      })),
      questionsImportant: item.questionsImportant?.map((question) => ({
        question,
        answer: answerChosen[question],
      })),
      questionsLenderInfluence: item.questionsLenderInfluence?.map((question) => ({
        question,
        answer: answerChosen[question],
      })),
      questionsFlexible: item.questionsFlexible?.map((question) => ({
        question,
        answer: answerChosen[question],
      })),
      feedback: item.feedback?.map((question) => ({
        question,
        answer: answerChosen[question],
      })),
    }));

    dispatch(
      postSurvey({
        surveyType: 'Finance Mortgage"',
        surveyData: surveyData,
      }),
    );
    navigate('/survey_thankyou');
  };

  return (
    <>
      <NavBar />
      <div className="surveyContainer">
        <div className="surveyHeader">
          <h1 className="surveyh1">{surveyText.title}</h1>
          <p>{surveyText.subtitle}</p>
          <h2 className="header"> {surveyText.financeMortgageTitle} </h2>
          <p> {surveyText.financeMortgageSubtitle} </p>
        </div>

        {financeMortgage.map((item, index) => (
          <div key={index}>
            <div className="content">
              <div>
                <h3 className="questionh3">{item.questionsEasy}</h3>
                <SurveyBtns
                  questionCategory={surveyBtnAnswers[0].difficult}
                  questionAnswer={handleAnswer}
                  question={item.questionsEasy}
                />
              </div>

              {item.questionsYesNo.map((question, questionIndex) => (
                <div key={question.questionId}>
                  <h3 className="questionh3">{question.text}</h3>
                  <SurveyBtns
                    questionCategory={surveyBtnAnswers[0].yesNo}
                    questionAnswer={handleAnswer}
                    question={question.text}
                  />
                </div>
              ))}

              <div>
                <h3 className="questionh3">{item.questionsLikely}</h3>
                <SurveyBtns
                  questionCategory={surveyBtnAnswers[0].likeyUnlikely}
                  questionAnswer={handleAnswer}
                  question={item.questionsLikely}
                />
              </div>

              <div>
                <h3 className="questionh3">{item.questionsSatisfied}</h3>
                <SurveyBtns
                  questionCategory={surveyBtnAnswers[0].satistied}
                  questionAnswer={handleAnswer}
                  question={item.questionsSatisfied}
                />
              </div>

              <div>
                <h3 className="questionh3">{item.questionsGoodPoor}</h3>
                <SurveyBtns
                  questionCategory={surveyBtnAnswers[0].poorGood}
                  questionAnswer={handleAnswer}
                  question={item.questionsGoodPoor}
                />
              </div>

              {item.questionsImportant.map((question, questionIndex) => (
                <div key={question.questionId}>
                  <h3 className="questionh3">{question.text}</h3>
                  <SurveyBtns
                    questionCategory={surveyBtnAnswers[0].important}
                    questionAnswer={handleAnswer}
                    question={question.text}
                  />
                </div>
              ))}

              {item.questionsLenderInfluence.map((question, questionIndex) => (
                <div key={question.questionId}>
                  <h3 className="questionh3">{question.text}</h3>
                  <SurveyBtns
                    questionCategory={surveyBtnAnswers[0].financeMostImportant}
                    questionAnswer={handleAnswer}
                    question={question.text}
                  />
                </div>
              ))}

              <div>
                <h3 className="questionh3">{item.questionsFlexible}</h3>
                <SurveyBtns
                  questionCategory={surveyBtnAnswers[0].fixedFlexible}
                  questionAnswer={handleAnswer}
                  question={item.questionsFlexible}
                />
              </div>

              <div>
                <h3 className="questionh3">{item.feedback}</h3>
                <TextField
                  id="outlined-multiline-static"
                  multiline
                  fullWidth
                  rows={4}
                  placeholder="Write here..."
                  question={item.feedback}
                  onChange={(e) => {
                    handleAnswer(item.feedback, e.target.value);
                  }}
                />
              </div>

              <Button variant="contained" id="submitSurveyBtn" onClick={handleSubmit}>
                {surveyText.submit}
              </Button>
            </div>
          </div>
        ))}
      </div>
      <Footer />
    </>
  );
};
